import { defineMessages } from 'react-intl';

import { MoreAbout, Props as MoreAboutProps } from 'components/seo/MoreAbout';
import { useIntlContext } from 'contexts/intl';

export const messages = defineMessages({
  whenFounded: {
    id: 'Seo.MoreAboutTeam.whenFounded',
    defaultMessage: 'When was {displayName} founded?',
  },
  whenFoundedAnswer: {
    id: 'Seo.MoreAboutTeam.whenFoundedAnswer',
    defaultMessage: '{displayName} was founded in {founded}.',
  },
  whoManager: {
    id: 'Seo.MoreAboutTeam.whoManager',
    defaultMessage: 'Who is {displayName} manager?',
  },
  whoManagerAnswer: {
    id: 'Seo.MoreAboutTeam.whoManagerAnswer',
    defaultMessage: '{displayName} manager is {manager}.',
  },
});

type Props = {
  displayName: string;
  founded?: string | null;
  manager?: string;
  specificItems?: MoreAboutProps['items'];
};

export const MoreAboutTeam = ({
  displayName,
  founded,
  manager,
  specificItems,
}: Props) => {
  const { formatMessage } = useIntlContext();
  return (
    <MoreAbout
      displayName={displayName}
      items={[
        !!manager && {
          question: formatMessage(messages.whoManager, { displayName }),
          answer: formatMessage(messages.whoManagerAnswer, {
            displayName,
            manager,
          }),
        },
        !!founded && {
          question: formatMessage(messages.whenFounded, { displayName }),
          answer: formatMessage(messages.whenFoundedAnswer, {
            displayName,
            founded,
          }),
        },
        ...(specificItems || []),
      ].filter(Boolean)}
    />
  );
};
